import { create } from "zustand";
import {
  documentsSubmitApi,
  submitApplicationApi,
} from "../../services/vendorMaster";
import { useBasicDataFormStore } from "./useBasicDataFormStore";
import { useVendorMasterStore } from "../useVendorMasterStore";
const GUID = localStorage.getItem("vendorGUID");
const locationCode = localStorage.getItem("locationCode");
const VendorType = localStorage.getItem("VendorType") === "Trade";

const mapApiToVendorDocuments = (api) => ({
  vendorGUID: api?.VendorGUID ?? GUID,
  documents: [
    {
      locationCode: api?.LocationCode ?? locationCode,
      panFile: api?.PANFile ?? "",
      gstFile: api?.GSTFile ?? "",
      cancelledCheque: api?.CancelledCheque ?? "",
      fssaiCertificate: api?.FSSAICertificate ?? "",
      organicCategory: api?.OrganicCategory ?? "",
      diabeticCategory: api?.DiabeticCategory ?? "",
      vattincstNumber: api?.VATTINCSTNumber ?? "",
      articalOfAssociation: api?.ArticalOfAssociation ?? "",
      partnershipDeed: api?.PartnershipDeed ?? "",
      rtgsDetails: api?.RTGSDetails ?? "",
      msmeDocument: api?.MSMEDocument ?? "",
      businessCodeOfConduct: api?.BusinessCodeOfConduct ?? "",
      sowDocument: api?.SOWDocument ?? "",
    },
  ],
});

const initial = {
  vendorGUID: GUID || "",
  documents: [
    {
      locationCode: locationCode || "",
      panFile: "",
      gstFile: "",
      cancelledCheque: "",
      fssaiCertificate: "",
      organicCategory: "",
      diabeticCategory: "",
      vattincstNumber: "",
      articalOfAssociation: "",
      partnershipDeed: "",
      rtgsDetails: "",
      msmeDocument: "",
      businessCodeOfConduct: "",
      sowDocument: "",
    },
  ],
};
export const useDocumentStore = create((set, get) => ({
  documnetData: {
    ...initial,
  },
  modal: false,
  showModal: (value) => set({ modal: value }),
  errors: null,
  setDocumentsFromApi: (api) =>
    set(() => ({
      documnetData: mapApiToVendorDocuments(api),
    })),

  handleInputChange: (field, value) =>
    set((state) => {
      const documents = [...state.documnetData.documents];
      if (field !== "vendorGUID") {
        documents[0] = {
          ...documents[0],
          [field]: value,
        };
      } else {
        state.documnetData = {
          ...state.documnetData,
          vendorGUID: value,
        };
      }
      return {
        documnetData: {
          ...state.documnetData,
          documents,
        },
        errors: { ...state.errors, [field]: "" },
      };
    }),

  validateForm: () => {
    const { documnetData } = get();
    const { basicData } = useBasicDataFormStore.getState();
    const { vendorDetailByGuid } = useVendorMasterStore.getState();
    const { VendorType } = vendorDetailByGuid?.Vendor || {};
    const newErrors = {};
    const documents = documnetData.documents[0];
    // Required fields from tradeData
    let requiredFields = {
      panFile: "Pan Detail is required",
      // gstFile: "Gst File is required",
      cancelledCheque: "Cancelled Cheque is required",
      // fssaiCertificate: "FSSAI Certificate is required",
      // msmeDocument: "MSME Document is required",
      // businessCodeOfConduct: "Business Code Of Conduct is required",
    };
    if (basicData.gstRegistration)
      requiredFields.gstFile = "Gst File is required";
    if (basicData.fssaiRegistration && VendorType !== "ZAEX")
      requiredFields.fssaiCertificate = "FSSAI Certificate is required";
    if (basicData.msmeRegistration)
      requiredFields.msmeDocument = "MSME Document is required";
    if (VendorType === "ZAEX" && !documents.businessCodeOfConduct)
      requiredFields.businessCodeOfConduct =
        "Business Code Of Conduct is required";
    if (VendorType === "ZAEX" && !documents.sowDocument)
      requiredFields.sowDocument = "SOW is required";
    // Run validations
    for (const key in requiredFields) {
      const value = documents[key];

      // Empty string, null, or undefined should count as missing
      if (value === "" || value === null || value === undefined) {
        newErrors[key] = requiredFields[key];
      }
    }
    set({ errors: newErrors });
    return Object.keys(newErrors).length === 0;
  },

  submitDocumentData: async (form) => {
    const { documnetData } = get();
    set({ loading: true });
    try {
      const response = await documentsSubmitApi(documnetData);
      return response?.Data[0];
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },
  submitApplication: async (form) => {
    set({ loading: true });
    try {
      const response = await submitApplicationApi(form);
      return response;
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },

  // Reset form
  resetForm: () =>
    set({
      tradeData: { ...initial },
      errors: null,
    }),
  deleteDocumentFile: (field) =>
    set((state) => {
      const documents = [...state.documnetData.documents];

      documents[0] = {
        ...documents[0],
        [field]: "", //  file remove
      };

      return {
        documnetData: {
          ...state.documnetData,
          documents,
        },
        errors: {
          ...state.errors,
          [field]: "", //  error bhi clear
        },
      };
    }),
}));
